(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'DateUtils'];

    function Customer ($resource, DateUtils) {
        var resourceUrl =  'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastLogin = DateUtils.convertDateTimeFromServer(data.lastLogin);
                        data.joined = DateUtils.convertDateTimeFromServer(data.joined);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
